import { render } from "./AProposDevComponent.vue?vue&type=template&id=5cd070ca&scoped=true"
import script from "./AProposDevComponent.vue?vue&type=script&lang=js"
export * from "./AProposDevComponent.vue?vue&type=script&lang=js"

import "./AProposDevComponent.vue?vue&type=style&index=0&id=5cd070ca&lang=scss&scoped=true"

import exportComponent from "/home/maud/code/ixperya2.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd070ca"]])

export default __exports__